import Resources from "../types/Resources";
import { permitContentVersions } from "../types/WorkPermit";
import { PermitType } from "./enums";

function getPermitNameResource(permitName: PermitType, contentVersion: number, resources: Resources): string {
    let resourceKey;
    switch (permitName) {
        case PermitType.DivingPermit:
            resourceKey =
                contentVersion >= permitContentVersions.version_2026_04
                    ? "DivingPermitName_2026_04"
                    : "DivingPermitName_Initial";
            break;
        case PermitType.UnderWaterWorkPermit:
            resourceKey =
                contentVersion >= permitContentVersions.version_2026_04
                    ? "UnderWaterWorkPermitName_2026_04"
                    : "UnderWaterWorkPermitName_Initial";
            break;
        default:
            resourceKey = permitName;
    }

    const resource = resources.get(resourceKey);

    if (!resource) {
        console.warn(`Resource for ${permitName} version ${contentVersion} not found.`);
        return "";
    }

    return resource;
}

export default { getPermitNameResource };
